var ServiceException = (function () {
    function ServiceException() {
    }
    ServiceException.parse = function (obj) {
        var result = new ServiceException();
        for (var prop in obj) {
            result[prop] = obj[prop];
        }
        return result;
    };
    ServiceException.prototype.toString = function () {
        return this.errorCode + ": " + this.description + (this.message ? "(" + this.message + ")" : "");
    };
    ServiceException.prototype.getDescripcion = function () {
        return this.description + (this.message ? "(" + this.message + ")" : "");
    };
    return ServiceException;
}());
export { ServiceException };
//# sourceMappingURL=exception.js.map